import React from 'react'
import { user } from '../../../helpers/user'
import { Box, Select } from '@chakra-ui/react'
import { api } from '../../../services/api'
import { useQuery } from 'react-query'
import { permissoesUsuariosPropostas } from '../../../utils/permissoesUsuariosProposta'

async function getAllCustomersActive() {
  try {
    const response = await api.get('/chamado/listar-vendedor-pedido')

    return response.data.filter((customer) => customer.apelido !== '<SEM VENDEDOR>')
  } catch (error) {
    console.log(error)
    return []
  }
}

export const SelectVendedores = ({ codCustomerSelected, setCodCustomerSelected }) => {
  const { data: customers } = useQuery({
    queryKey: 'customers',
    queryFn: getAllCustomersActive,
    staleTime: 30 * 1000, // 30 seconds
    refetchOnWindowFocus: false,
  })

  if (!permissoesUsuariosPropostas[user?.codigo_usuario]) return null

  return (
    <Box position="absolute" top="50%" right="330" transform="translateY(-50%)">
      <Select value={codCustomerSelected} onChange={(e) => setCodCustomerSelected(e.target.value)} w="200px">
        <option value="">Selecione um vendedor</option>
        <option value="0">Todos</option>
        {customers?.map((customer) => (
          <option key={customer.codigo_usuario} value={customer.codigo_usuario}>
            {customer.apelido}
          </option>
        ))}
      </Select>
    </Box>
  )
}
